import { $$ } from '../helpers/shortcuts';

function initializeCheckboxes() {
  $$('input[type="checkbox"]').forEach(($checkbox) => {
    const icon = document.createElement('i');
    icon.classList.add('ri-check-line', 'checkbox-icon');
    icon.setAttribute('aria-hidden', true);
    $checkbox.parentNode.appendChild(icon);
  });
}

export { initializeCheckboxes };
